// Define the options for react-select
export const conferenceOptions = [
    { value: 1, label: 'Zoom', id: 'Zoom', src: "./assets/zoom.svg" },
    { value: 4, label: 'Webex', id: 'Webex', src: "./assets/webx.png" },
    { value: 2, label: 'Google Meet', id: 'Google Meet', src: "./assets/meet.png" },
    { value: 3, label: 'Microsoft Teams', id: 'Microsoft Teams', src: "./assets/teams.png" }
];